// @flow
import { themeStyle } from '../colorPalettes'

import { darkTheme } from './darkTheme'

import type { ThemeType } from '..'

const onlymotorsThemeName = 'onlymotors'

export const themeOnlymotors: ThemeType = {
  name: onlymotorsThemeName,
  getThemeVariation: (themeVariation: string) => {
    switch (themeVariation) {
      case themeStyle.dark:
        return darkTheme
      default:
        return darkTheme
    }
  },
}
